import { useEffect, useState } from "react";
import { MALLIGYONG } from "../constants";
import { DATA_INFO, MALLIGYOUNG_DESCRIPTIONS } from "../constants/descriptions";
import useMalligyongDataLoader from "../hooks/useMalligyongDataLoader";
import DataInfo from "../components/features/Malligyong/DataInfo";

import styled from "styled-components";
import Explanation from "../components/shared/ui/Explanation";
import Malligyong3D from "../components/features/Malligyong/Malligyong3D";
import Malligyong2D from "../components/features/Malligyong/Malligyong2D";
import MalligyongEventTable from "../components/features/Malligyong/MalligyongEventTable";
import "../styles/malligyongMobile.css";

const MalligyongTracker = () => {
  const { accessTableData, probingTableData } = useMalligyongDataLoader();
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    if (Object.keys(accessTableData).length === 0) return;
    const initialKey = Object.keys(accessTableData)[0];
    const initialData = accessTableData[initialKey][0];

    setSelectedData(initialData);
  }, [accessTableData]);

  const handleSelectData = data => {
    setSelectedData(data);
  };

  return (
    <Container>
      <DataInfo
        siteDescription={DATA_INFO.MALLIGYOUNG.siteDescription}
        dataInfo={DATA_INFO.MALLIGYOUNG.dataInfo}
      />
      <Explanation target={MALLIGYOUNG_DESCRIPTIONS} />
      <Layout className="malligyong__layout">
        <Item>
          <Malligyong3D
            enteringTime={selectedData.entering}
            selectedNoradId={selectedData.noradId}
            title={MALLIGYONG}
          />
        </Item>
        <Item>
          <Malligyong2D
            enteringTime={selectedData.entering}
            selectedNoradId={selectedData.noradId}
            title={MALLIGYONG}
          />
        </Item>
        <Item>
          <MalligyongEventTable
            accessTableData={accessTableData}
            probingTableData={probingTableData}
            selectedData={selectedData}
            handleSelectData={handleSelectData}
          />
        </Item>
      </Layout>
    </Container>
  );
};

export default MalligyongTracker;

const Container = styled.main`
  position: relative;
  padding: 1rem;
  box-sizing: border-box;
  /* 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 3rem;
  width: auto;
  height: auto; */
`;

const Layout = styled.div`
  /* width: 100%; */
  margin: 0 auto;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 35rem));
  grid-template-rows: 46rem;
  justify-content: center;

  grid-template-areas:
    "item1"
    "item2"
    "item3";

  /* @media (min-width: 480px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "item1 item2"
      "item3 item3";
  } */

  /* @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas: "item1 item2 item3";
  } */
`;

const Item = styled.div`
  &:nth-child(1) {
    grid-area: item1;
  }
  &:nth-child(2) {
    grid-area: item2;
  }
  &:nth-child(3) {
    grid-area: item3;
  }
`;
